import React from "react";
import { useState, useEffect } from "react";
import styled from "styled-components";
import { Button, Col, Input, Modal, Pagination, Select, Space, Spin, Table } from "antd";
import { CheckOutlined, DeleteFilled, PlusCircleOutlined, PlusOutlined, MenuOutlined } from "@ant-design/icons";

import ControlBox from "./ControlBox";
import axios from "axios";

const backend = process.env.REACT_APP_BACKEND
const StyledTable = styled((props) => <Table {...props} />)`
  && .selectedRow > td {
    background: paleturquoise;
  }
  && .selectedRow:hover > td {
    background: paleturquoise;
  }
  && tbody > tr:hover > td {
    background: azure;
  }
  .ant-table {
    display: flex;
    flex-direction: column;
  }
  .ant-table > .ant-table-container {
    /*flex-grow: 1;*/
    max-height: 90%;
  }

  
  .custom-footer {
    background-color: #fff; /* 적절한 배경색 지정 */
    padding: 10px; /* 원하는 패딩값 설정 */
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .ant-table-pagination.ant-pagination {
    display: none;
  }
  .ant-table-footer {
    width: 100%;
    padding: 0px;
  }
`



function WordManage ({ stateHandlerUp, reRender, vocabularyData, languageGroup }) {

  const [sourceData, setSourceData] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [rightBox, setRightBox] = useState([0,{}])
  const [curLanguage, setCurLanguage] = useState("L0010")
  const [posGroup, setPosGroup] = useState([])

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1, // 현재 표시할 페이지
      pageSize: 100, // 한 페이지에 표시할 레코드 수
      showSizeChanger: true, // pageSize변경옵션을 표시할지 여부
      pageSizeOptions: [5, 10, 50, 100, 200],
      showQuickJumper: true, // page 점프
      hideOnSinglePage: false, //pagenation 자체를 사용하고 싶지 않은 경우 pageSize를 최고로 높이면 됨
      showTotal: (total)=>`total ${total} items`,
      total:0
    },
    filters: {
      cefrFilter: "all",
      posFilter: "all",
      searchFilter: "",
    },
    sorter: {

    }
  });

  const stateHandler =(stateName, state) => {
    switch (stateName) {
      case "cefrFilter" :
        setTableParams({
          ...tableParams,
          filters: {
            ...tableParams.filters,
            cefrFilter: state
          },
          pagination: {
            ...tableParams.pagination,
            current: 1
          }
        })
        break

      case "posFilter" :
        setTableParams({
          ...tableParams,
          filters: {
            ...tableParams.filters,
            posFilter: state
          },
          pagination: {
            ...tableParams.pagination,
            current: 1
          }
        })
        break

      case "searchFilter" :
        setTableParams({
          ...tableParams,
          filters: {
            ...tableParams.filters,
            searchFilter: state
          },
          pagination: {
            ...tableParams.pagination,
            current: 1
          }
        })
        break

      case "curLanguage" :
        setCurLanguage(state)
        break

      default : 
        break
    }
  }

  const paginationHandler = (current,pageSize) => {
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: current,
        pageSize: pageSize,
      }
    })
  }

  const columns = [
    {
      title: "No.",
      dataIndex: "number",
      key: "number",
      width: "80px"
    },
    {
      title: "영어단어",
      dataIndex: "word",
      key: "word",
      width: "180px"
    },
    {
      title: "품사",
      dataIndex: "pos_name",
      key: "pos_name",
      width: "100px"
    },
    {
      title: "CEFR레벨",
      dataIndex: "cefr_gpt",
      key: "cefr_gpt",
      width: "100px",
    },
    {
      title: `해석(${languageGroup.filter(el=>el.value===curLanguage)[0].label})`,
      dataIndex: "translate_text",
      key: "translate_text",
      width: "180px",
    },
    {
      title: "이미지 수",
      dataIndex: "image_count",
      key: "image_count",
      width: "100px",
      render: (_)=><div style={{color : _ ? null : "red"}}>{_}</div>
    },
    {}
  ]

  const getSourceData = () => {
    setLoading(true)
    const { current, pageSize } = tableParams.pagination;
    const sorterCol = tableParams.sorter.column?.dataIndex || "code"
    const sorterDirection = tableParams.sorter.order === "descend" ? "DESC" : "ASC"
    const { posFilter, cefrFilter, searchFilter} = tableParams.filters

    axios.get(`${backend}/contents/word_dictionary/vocabulary/words/list`,
    {params:{
      code: vocabularyData.VocabularyExMaster_code,
      current: current,
      pageSize: pageSize,
      sorterCol: sorterCol,
      sorterDirection: sorterDirection,
      posFilter: posFilter,
      cefrFilter: cefrFilter,
      searchFilter: searchFilter,
      languageCode: curLanguage
    }})
    .then(res=> {
      const total = res.data.data[1][0]["FOUND_ROWS()"]
      const curTotal = total - (pageSize * (current -1))
      const newSourceData = res.data.data[0].map((el, idx) => {
        el.number = curTotal - idx
        return el
      })
      
      setSourceData(newSourceData)
      setTableParams({
        ...tableParams,
        pagination: {
          ...tableParams.pagination,
          total: total
        }
      })
      setSelectedKeys([])
      setSelectedRows([])
      setLoading(false)
    })
    .catch(err=> {
      setLoading(false)
      console.log(err)
    })
  }
 
const deleteHandler = () => {
  
  axios.delete(`${backend}/contents/word_dictionary/vocabulary/words/total_words/${selectedKeys}`)
  .then(res=>{
    getSourceData()
    stateHandlerUp("reRender")
  })
  .catch(err=>{
    console.log(err)
  })
}
  

  const rowSelection = {
    selectedRowKeys: selectedKeys,
    type: "checkbox",
    onChange: (keys, rows) => {
      setSelectedRows(rows.sort((a, b) => a.num - b.num));
      setSelectedKeys(keys.sort((a, b) => a - b));
    },
    getCheckboxProps: (record) => ({
      // disabled: record.hideCheckbox, // 특정 조건일 경우 사용하지 체크하지 못하도록 함
      // className: record.hideCheckbox ? "hidden-checkbox" : "" // 클래스 설정 가능

    })
  }

  // 각 행별 이벤트를 모아놓은 객체를 리턴한다. 필요한 경우에만 사용하도록.
  const onRowHandler = (record, rowIdx) => {
    return {
      // onClick : () => {
      //   setRightBox([!rightBox[0] ? 1 : 0,{}])
      // }
    }
  }

  useEffect(()=>{
    getSourceData()
  },[reRender, tableParams.filters, tableParams.pagination.current, tableParams.pagination.pageSize, curLanguage, vocabularyData.VocabularyExMaster_code])

  useEffect(()=>{
    axios.get(`${backend}/contents/word_dictionary/vocabulary/words/groups`)
    .then(res=> {
      setPosGroup(res.data.data)
    })
    .catch(err=>{
      console.log(err)
    })
  },[])

  return (
    <div style={{display: "flex", flexDirection:"column", height:"100%"}}>
      <Spin className="mySpin" spinning={loading}>
        <div style={{display:"flex", justifyContent:"space-between", marginBottom:"10px"}}>
          <span style={{ minWidth: "100px", textAlign: "left" }}>단어 목록</span>
          <ControlBox stateHandler={stateHandler} posGroup={posGroup} filters={tableParams.filters} languageGroup={languageGroup} curLanguage={curLanguage}/>
        </div>
        
        <div style={{ display: "flex", height:"100%", width:"100%", overflow: "auto" }}>
          <StyledTable
            className="pageTable"
            onRow={onRowHandler}
            rowSelection={rowSelection} // 체크박스 활용하고 싶다면 활성화
            columns={columns}
            dataSource={sourceData}
            rowKey="id"
            // onChange={tableParamsHandler}
            pagination={tableParams.pagination}
            style={{flexGrow:1, overflow:"auto"}}
            scroll = {{ x:"max-content", y:"max-content"}}
            footer={()=>
              <div className="custom-footer">
                <Button disabled={!selectedKeys.length} onClick={deleteHandler}><DeleteFilled/>선택단어 제외</Button>
                <Pagination {...tableParams.pagination} onChange={paginationHandler}/>
              </div>}
          />
        </div>
      </Spin>
    </div>
  )
}

export default WordManage